module.exports = __webpack_public_path__ + "static/media/github_logo_6.1873d04e.png";